import { render, staticRenderFns } from "./Lost.vue?vue&type=template&id=53337720&scoped=true&"
import script from "./Lost.vue?vue&type=script&lang=js&"
export * from "./Lost.vue?vue&type=script&lang=js&"
import style0 from "./Lost.vue?vue&type=style&index=0&id=53337720&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53337720",
  null
  
)

export default component.exports